export const SIGN_UP = "SIGN_UP";
export const SIGN_IN = "SIGN_IN";